import React, { Component } from 'react';
import { Navbar, NavbarBrand, Collapse} from 'mdbreact';

class LoginL extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            isWideEnough: false,
            dropdownOpen: false
        };
    this.onClick = this.onClick.bind(this);
    this.toggle = this.toggle.bind(this);
    }
    onClick(){
        this.setState({
            collapse: !this.state.collapse,
        });
    }
    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
  render() {
    return (
      <div>       
        <Navbar color="indigo" dark expand="md" scrolling>
                <NavbarBrand href="/home">
                <strong>Support Tools</strong>&nbsp;
                </NavbarBrand>
                <Collapse isOpen = { this.state.collapse } navbar>            
                </Collapse>  
        </Navbar><br/>
      </div>
    );
  }
}
export default LoginL;


// WEBPACK FOOTER //
// ./src/layout/loginLayout.jsx